import { Aviso, Botao, Dialogo, type PropsBotao } from "@mtc/ui";
import { useEffect, useLayoutEffect, useRef, type FormEvent, type ReactNode } from "react";
import { useAcao } from "../api";

/**
 * Dialogo de uma acao do painel: campos, erro do backend em destaque e o botao que confirma. `aoEnviar` faz a
 * chamada; se der certo, fecha e roda `aoConcluir`. `aoAbrir` limpa os campos a cada abertura. `rotuloFechar` troca o
 * "Cancelar" do rodape quando a propria acao e cancelar algo (ex.: "Voltar" ao lado de "Cancelar mensalidade").
 */
export function DialogoDeAcao({ aberto, aoFechar, titulo, descricao, botao, variante = "primario", podeEnviar = true, aoAbrir, aoEnviar, aoConcluir, rotuloFechar = "Cancelar", children }: { aberto: boolean; aoFechar: () => void; titulo: string; descricao?: ReactNode; botao: string; variante?: PropsBotao["variante"]; podeEnviar?: boolean; aoAbrir?: () => void; aoEnviar: () => Promise<unknown>; aoConcluir: () => void; rotuloFechar?: string; children?: ReactNode }) {
  const acao = useAcao();
  // So na abertura, e antes do navegador desenhar: com `useEffect` o campo aparecia vazio por um instante e o que fosse
  // digitado nele era sobrescrito pelo `aoAbrir` (visto no e2e da Global no WebKit, 25/10: o telefone novo voltava).
  useLayoutEffect(() => { if (aberto) { acao.limpar(); aoAbrir?.(); } }, [aberto]);
  // O erro mora no topo do formulario. Em dialogo comprido, quem clicou no botao la embaixo nao via nada acontecer
  // (visto no "Novo repasse", 29/09): o erro rola ate ficar a vista.
  const erro = useRef<HTMLDivElement>(null);
  useEffect(() => { if (acao.erro) erro.current?.scrollIntoView({ block: "nearest", behavior: "smooth" }); }, [acao.erro]);
  const enviar = async (ev: FormEvent) => {
    ev.preventDefault();
    if (!(await acao.rodar(aoEnviar))) return;
    aoFechar();
    aoConcluir();
  };
  return (
    <Dialogo aberto={aberto} aoFechar={aoFechar} titulo={titulo} descricao={descricao}>
      <form className="mtc-formulario" onSubmit={enviar} noValidate>
        {acao.erro && <div ref={erro}><Aviso tipo="erro">{acao.erro}</Aviso></div>}
        {children}
        <div className="mtc-dialogo__rodape">
          <Botao variante="fantasma" onClick={aoFechar}>{rotuloFechar}</Botao>
          <Botao type="submit" variante={variante} carregando={acao.carregando} disabled={!podeEnviar}>{botao}</Botao>
        </div>
      </form>
    </Dialogo>
  );
}
